import React from 'react'
import { LookingForListingWrapper } from './styled'
import { Box } from '../../../../components/styled/Elements'
import LookingForCards from './LookingForCards'


const LookingForListing = ({showAll, setShowAll}) => {
  return (
    <LookingForListingWrapper>
        
        <Box className='w-100'>
            <LookingForCards showAll={showAll} setShowAll={setShowAll} />
        </Box>
    </LookingForListingWrapper>
  )
}

export default LookingForListing


